import * as user from './user';
import * as tracking from './tracking';
import * as crm from './crm';
import * as map from './map';
import * as billing from './billing';
import * as notification from './notification';
import * as applog from './applog';
import * as crmBitrix from './crm-bitrix';
import * as sim from './sim';
import * as monitor from './monitor';

const API = { user, tracking, crm, map, billing, notification, applog, crmBitrix, sim, monitor };

export default API;



// WEBPACK FOOTER //
// ./src/api/index.js